"use strict";
exports.__esModule = true;
var querystring = require("querystring");
var baseUrl = "/present_search?";
function getSearchUrl(presentee, age, occasion) {
    var qs = querystring.stringify({ presentee: presentee, age: age, occasion: occasion });
    return baseUrl + qs;
}
exports.getSearchUrl = getSearchUrl;
